<script>
  import options from './SortingComponent.options'
  export default options
</script>

<template>
  <section class="nlx-sorting-component">
    <div class="nlx-sorting-component__container">

      <button class="nlx-sorting-component__sort" 
        :class="sortClassModifier" 
        @click="toggleSortingDropdown">
        <span class="nlx-sorting-component__sort-label">{{getLabel('sortingLabel')}}:</span>
        <span class="nlx-sorting-component__sort-type">{{activeSortOption.displayName}}</span>
        <div class="nlx-sorting-component__sort-chevron">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
        </div>
      </button>

      <ul class="nlx-sorting-component__dropdown">
        <template v-for="(option,key) in sortingOptions" :key="key">
          <li>
            <input class="nlx-filter-component__filter-checkbox" 
              :id="`sort${key}`" 
              :checked="option.selected"
              type="checkbox">
            <label class="nlx-filter-component__filter-checkbox-label" 
              :for="`sort${key}`"
              @click.prevent="selectSort(option)">
              {{option.displayName}}
            </label>
          </li>
        </template>
      </ul>

    </div>
  </section>
</template>
